module.exports = __webpack_public_path__ + "static/media/support.ea3ed4bd.png";